/**
 * Created by zhaoy on 19:45.
 * 修改资料
 */
import React from 'react';
import {Icon, Divider, Avatar} from "antd";
import "../recharge/RechargeDetai.css"
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Card, WingBlank, List, Toast, Tabs, WhiteSpace, Button, Picker } from "antd-mobile";
import UploadEnclosure from "../../components/UploadEnclosure";
import {getIntValue, getStrValue, isObjEmpty} from "../../utils/common";

class ElectronicCardDataDetail extends React.Component{
    constructor(props){
        super(props);
        this.state={
            name:'RechargeDetail',
            data:{

            },
            fileList: [],
            IMEI: this.props.match.params.IMEI,
            data: this.props.match.params.data,
            nickname: null,
            sim: null,
        };
    }


    componentDidMount(){
        document.title = '宝贝资料'

    }

    render(){
        const {stuPhoto, fileList, data} = this.state;

        return <div className="padding_15">

                {data=='nickname'?
                <div className="item_sty" onChange={this.nicknameValueCom}>
                    <div className="left_title">宝贝昵称</div>
                    <input ref='nickname' className="text-right right_input" type="text" placeholder="请输入昵称（最多6个字符）" maxLength={6} autoFocus="autoFocus" value={this.state.nickname}/>
                </div>:
                <div className="item_sty" onChange={this.simValueCom}>
                    <div className="left_title">宝贝手机号</div>
                    <input ref='sim' className="text-right right_input" type="text" placeholder="请输入宝贝手机号" maxLength={11} value={this.state.sim}/>
                </div>}
            <div className="comhline_sty1"></div>
            <Button type="primary" block className='commonButton' style={{marginTop: '35px',borderRadius: '30px',}}
                                    onClick={this.addNicknameBySim}>保存</Button>

        </div>
    }

    addNicknameBySim = () => {
        Toast.loading('保存中...')
        const {IMEI, nickname, sim} = this.state

        if (nickname === null && sim === null) {
            Toast.fail('请完善输入项！')
            return
        }

        fetchPost(API.ADD_NICKNAME_SIM, {
            IMEI: IMEI,
            nickname: nickname,
            sim: sim,
        }).then(response => {
            Toast.hide()
            this.backTask = setTimeout(() => {
                this.props.history.goBack();
            }, 1000)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('保存失败')
            }
        })
    }

    nicknameValueCom = (event)=>{
        //获取用户名的值
        let nickname = this.refs.nickname.value;
        //获得内容的值
        this.setState({
            nickname:nickname,
        })
    }

    simValueCom = (event)=>{
        //获取用户名的值
        let sim = this.refs.sim.value;
        //获得内容的值
        this.setState({
            sim:sim,
        })
    }

}

export  default ElectronicCardDataDetail;